import React from 'react';
import './error.css';
const Error = ({ message }) => {
  return <div className="error">{message}</div>;
};

export default Error;
